/**
 * Endpoint Ubicaciones — backend REAL (everex-traza-back).
 *
 * Tira GET /api/gln y valida la respuesta contra `GetUbicacionesResponse`.
 * El backend serializa cada fila de la tabla `gln` con shape compatible:
 *   id (INT en DB → string), nombre, gln, tipoActor.
 */

import { GetUbicacionesResponse, type Ubicacion } from '@/api/contracts/ubicaciones';
import { apiFetch } from '@/api/http';

export async function getUbicaciones(): Promise<Ubicacion[]> {
  const data = await apiFetch<unknown>('/gln', { auth: true });
  return GetUbicacionesResponse.parse(data);
}

/**
 * PUT /api/gln/default — marca el GLN como default del usuario autenticado.
 * El backend actualiza `user_gln.is_default` y devuelve el id seteado.
 */
export async function setDefaultGln(glnId: string): Promise<{ glnId: string }> {
  return apiFetch<{ glnId: string }>('/gln/default', {
    auth: true,
    method: 'PUT',
    body: { glnId: Number(glnId) },
  });
}
